import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form';
import CheckoutModal from '../../components/pages_components/checkout/CheckoutModal';

import { generalAssets, checkoutAssets } from '../../assets/media';
const { logo } = generalAssets.brandLogo
const { methods } = checkoutAssets

const CheckoutPage = () => {
    const { register, getValues, handleSubmit, formState: { errors } } = useForm()
    console.log("errors", errors)

    // state
    const [form, setForm] = useState({})
    const [isSubmitted, setisSubmitted] = useState(false)


    // functions
    const extractFormData = () => {


        setisSubmitted(true)
        setForm(

            {
                nameOnCard: getValues('nameOnCard'),
                cardNumber: getValues('cardNumber'),
                cardExpiry: getValues('cardExpiry'),
                cardCVV: getValues('cardCVV'),
                isAgree: getValues('isAgree'),
                isSave: getValues('isSave')
            }
        )

    }

    // useEffect
    useEffect(() => {

        setisSubmitted(false)

        console.log("FormDetails", form)
    }, [form, isSubmitted])

    // validation methods

    const checkIfExactly = (v, givenValue = 1) => {
        return v.toString().split("").length === givenValue
    }
    const checkIfPositive = (v) => {
        return parseInt(v) >= 0
    }



    return (
        <div className="CheckoutPage">
            <CheckoutModal isOpen={false} />

            <div className="checkoutPageWrapper w-[80vw] lg:w-[30rem] h-screen mx-auto px-5 py-2 flex flex-col items-center xl:justify-center">
                <div className="logo p-5 lg:p-0">
                    <img src={logo} className=" h-[45px] lg:h-[5rem] object-contain" alt="" />
                </div>

                <div className="form w-full mt-5">

                    <div className="title">
                        <h3 className='text-[24px] font-[700] lg:text-[1.5rem] lg:font-semibold text-center lg:text-left'>Billing and Payment</h3>
                    </div>

                    <form onSubmit={handleSubmit(extractFormData)}>
                        <p className={`mt-5 text-[14px] leading-[24px] font-[600] lg:hidden ${errors.nameOnCard && 'text-red-600'}`}>Select Your Card *</p>
                        <div className="field flex bg-[#f9f9f9] rounded justify-between p-2  border border-gray-200 mt-2 lg:mt-5">
                            <input {...register("nameOnCard", { required: true })} id="nameOnCard" type="text" className="text-[14px] border-none bg-[#f9f9f9] w-full outline-none" placeholder='Enter Name on Card' />
                            <img src={methods} className=" h-[1.4rem] lg:h-[1.5rem] object-contain" alt="" />
                        </div>
                        <p className={`${errors.cardNumber && 'text-red-600 '} mt-5 text-[14px] leading-[24px] font-[600] lg:hidden`}>Your Card Number *</p>
                        <div className="field mt-2 lg:mt-5 flex bg-[#f9f9f9] rounded justify-between p-2  border border-gray-200">
                            <input type="number" {...register("cardNumber",
                                {
                                    required: true,
                                    validate: {
                                        positive: v => checkIfPositive(v) || "must be positive",
                                        exactly: v => checkIfExactly(v, 13) || "must be 13 digits",
                                    },
                                    valueAsNumber: true

                                })}
                                className="text-[14px] border-none bg-[#f9f9f9] w-full outline-none" id="cardNumber" placeholder='Enter Your 13 Digit Card Number' />
                        </div>
                        <p className={`${errors.cardExpiry && 'text-red-600'} mt-5 text-[14px] leading-[24px] font-[600] lg:hidden`}>Card Expiry *</p>

                        <div className="field mt-2 lg:mt-5 flex bg-[#f9f9f9] rounded justify-between p-2  border border-gray-200">
                            <input {...register("cardExpiry", { required: true })} type="date" className="text-[14px] border-none bg-[#f9f9f9] w-full outline-none" id="cardExpiry" placeholder='Expiry Date of Card' />
                        </div>
                        <p className={`${errors.cardCVV && 'text-red-600'} mt-5 text-[14px] leading-[24px] font-[600] lg:hidden`}>CVV *</p>

                        <div className="field lg:mt-5 flex bg-[#f9f9f9] rounded justify-between p-2  border border-gray-200">
                            <input  {...register("cardCVV",
                                {
                                    required: true,
                                    validate: {
                                        positive: v => checkIfPositive(v) || "must be positive",
                                        exactly: v => checkIfExactly(v, 3) || "must be 3 digits",
                                    },
                                    valueAsNumber: true
                                })} type="number" className="text-[14px] border-none bg-[#f9f9f9] w-full outline-none" id="cardCVV" placeholder='Enter 3-Digit CVV' />
                        </div>

                        <div className="totalAmount mt-5">
                            <h3 className='text-[1rem] font-bold lg:text-[1.2rem]'>Your Total Amount: $1237.99</h3>
                        </div>

                        <div className="agreement mt-5">
                            <div className="check1 flex items-center">
                                <div className="checkBtn mt-1">
                                    <input value={"yes"} className={`${errors.isAgree && 'accent-red-600'}`} {...register("isAgree", { required: true })} type="checkbox" id="isAgree" />
                                </div>
                                <div className={`desc`}>
                                    <p className='text-[12px] lg:text-base ml-2'>I agree to all <Link className='underline'>Terms & Conditions </Link><span className={`${errors.isAgree && 'text-red-600 font-bold text-md '}`}>{errors.isAgree && '*'}</span></p>
                                </div>
                            </div>
                            <div className="check1 mt-2 flex items-center">
                                <div className="checkBtn lg:mt-1">
                                    <input {...register("isSave", { required: false })} type="checkbox" id="isSave" />
                                </div>
                                <div className="desc">
                                    <p className='text-[12px] lg:text-base ml-2'>Save card details   </p>
                                </div>
                            </div>

                        </div>
                        <div className="submitBtn mt-5">
                            <button className='bg-[#FFD700] w-full p-2' type="submit">MAKE PAYMENT</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default CheckoutPage